/* ************************************************** *
* Initialise various JavaScript controls on page load *
* *************************************************** */
$(function () {

    /* ******************************************************* *
    * Google Analytics: change UA-XXXXX-X to be your site's ID *
    * ******************************************************** */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');

    ga('create', 'UA-22737045-1', 'auto');
    ga('send', 'pageview');

    /* ********************************************************* *
    * Take to the parent link when clicked (Navigation Dropdows) *
    * ********************************************************** */
    $('.dropdown-toggle').click(function () {
        var location = $(this).attr('href');
        window.location.href = location;
        return false;
    });

    /* *************************************************** *
    * Geolocate the client (call the geolocate() function) *
    * **************************************************** */
    geolocate();

    /* ***************************************************************** *
    * Prevent geolocation button from firing when pressing Enter on form *
    * ****************************************************************** */

    $('input#Location').keypress(function (e) {
        if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {

            $('button[type=submit]:visible').first().click();

            return false;
        } else {
            return true;
        }
    });


    /* **************** *
    * Clear input field *
    * ***************** */
    $('input#Location').keyup(function () {
        if ($(this).val().length > 0) {
            $('.btn-clear-absolute').show();
        } else {
            $('.btn-clear-absolute').hide();
        }
    });

    $('#start').keyup(function () {
        if ($(this).val().length > 0) {
            $('.btn-clear-absolute').show();
        } else {
            $('.btn-clear-absolute').hide();
        }
    });

    if (($('input#Location').length && $('input#Location').val().length > 0) ||
        ($('#start').length && $('#start').val().length > 0)) {
        $('.btn-clear-absolute').show();
    }

    $('.btn-clear').click(function () {
        if ($('input#Location').length) {
            $('input#Location').val('').focus();
        } else if ($('#start').length) {
            $('#start').val('').focus();
        }

        $('.btn-clear-absolute').hide();

        return false;
    });

    /* ************************ *
    * Search form tenure toggle *
    * ************************* */
    $('.tenure-toggle').click(function () {
        var tenure = $(this).find('#Tenure').val();

        // Replace the price dropdowns with appropriate valuse based on the tenure type
        switch (tenure) {
            case 'Sale':
                $('#PriceMin').replaceWith($('#dropdown-sale-min').html());
                $('#PriceMax').replaceWith($('#dropdown-sale-max').html());
                break;
            case 'Rent':
                $('#PriceMin').replaceWith($('#dropdown-rent-min').html());
                $('#PriceMax').replaceWith($('#dropdown-rent-max').html());
                break;
        }

        // Set the min price to the lowest value and the max price to the highest value
        $('#PriceMin').val($('#PriceMin option:first').val());
        $('#PriceMax').val($('#PriceMax option:last').val());
    });

    $('#btn-filter').click(function () {
        $('#filter-box').slideToggle('fast');

        return false;
    });


    $('#btn-alert').click(function () {
        $('#alert-box').slideToggle('fast');

        return false;
    });
    $('button[data-behaviour=expand-draw-search-filter]').click(function () {
        if ($(this).hasClass('collapsed')) {
            $('.draw-search-box').removeClass('hidden');

            $(this).removeClass('collapsed');
            $(this).addClass('expanded');

            $('span.btn-text', this).text('Collapse Navigation');
            $('span', this).next().removeClass('fa-angle-double-down');
            $('span', this).next().addClass('fa-angle-double-up');
        } else {
            $('.draw-search-box').addClass('hidden');

            $(this).removeClass('expanded');
            $(this).addClass('collapsed');

            $('span.btn-text', this).text('Expand Navigation');
            $('span', this).next().removeClass('fa-angle-double-up');
            $('span', this).next().addClass('fa-angle-double-down');
        }

        return false;
    });

    $('#timeEvent').click(function () {

        $('#timeInfo').toggleClass("timeShown");
        $('#timeInfo').css("top", ($(this).offset().top - 65) + 'px');
    });
    $('button[data-behaviour=expand-member-branch]').click(function () {
        if ($(this).hasClass('collapsed')) {
            $('#member-branch').removeClass('hidden');

            $(this).removeClass('collapsed');
            $(this).addClass('expanded');

            $('span.btn-text', this).text('Hide Contact Details');
            $('span', this).next().removeClass('fa-angle-double-down');
            $('span', this).next().addClass('fa-angle-double-up');

            initBranchMap();
        } else {
            $('#member-branch').addClass('hidden');

            $(this).removeClass('expanded');
            $(this).addClass('collapsed');

            $('span.btn-text', this).text('Show Contact Details');
            $('span', this).next().removeClass('fa-angle-double-up');
            $('span', this).next().addClass('fa-angle-double-down');
        }

        return false;
    });

    $('button[data-behaviour=collapse-side-navigation]').click(function () {
        if ($(this).hasClass('expanded')) {
            $('#side-navigation').addClass('hidden');

            $(this).addClass('with-borders');
            $(this).parent().css('background-color', 'transparent');
            $(this).removeClass('expanded');
            $(this).addClass('collapsed');

            $('span', this).next().removeClass('fa-minus-circle');
            $('span', this).next().addClass('fa-plus-circle');
        } else {
            $('#side-navigation').removeClass('hidden');

            $(this).removeClass('with-borders');
            $(this).parent().css('background-color', '#999');
            $(this).removeClass('collapsed');
            $(this).addClass('expanded');

            $('span', this).next().removeClass('fa-plus-circle');
            $('span', this).next().addClass('fa-minus-circle');
        }

        return false;
    });

    /* ********************* *
    * Results page dropdowns *
    * ********************** */
    // Parse current query string into a JavaScript object - remove leading question mark and re-insert space
    var params = $.deserialize(window.location.search.substring(1).replace('+', ' '));

    // Result sorting and filtering dropdowns
    $('select[data-behaviour=update-search-params]').change(function () {
        var selectedOption = $(this).find('option:selected');

        // Get targeted search params and values from data attributes
        var selectedParams = selectedOption.data('params').toString().split(',');
        var selectedVals = selectedOption.data('vals').toString().split(',');

        // Replace the value of each targeted param with the corresponding value
        for (var i = 0; i < selectedParams.length; i++) {
            params[selectedParams[i]] = selectedVals[i];
        }

        // Reset paging and reload
        params['page'] = 1;
        window.location = '?' + jQuery.param(params, true);
    });

    /* ******************** *
    * Initialise branch map *
    * ********************* */
    initBranchMap();

    /* ********************* *
    * Initialise results map *
    * ********************** */
    $('a[data-behaviour=show-results-map]').click(function () {
        setTimeout(function () {
            initResultsMap();
            $('.pager-wrap').hide();
        }, 100);
    });

    /* ********************** *
    * Initialise property map *
    * *********************** */
    $('a[data-behaviour=show-property-map]').click(function () {
        setTimeout(function () {
            initPropertyMap();
        }, 100);
    });

    $('a[data-behaviour=show-list-view]').click(function () {
        $('.pager-wrap').show();
    });

    $('a[data-behaviour=show-property-streetView]').click(function () {
        setTimeout(function () {
            initPropertyStreetView();
        }, 100);
    });

    /* ************** *
    * Initialise tabs *
    * *************** */
    initTabView();

    /* **************** *
    * Responsive slider *
    * ***************** */

    function lazyLoading($slider, i) {

        var slide = $slider.find('li .imageSlideBackground:eq(' + i + ')');
        var img = slide.data('src');
        if (!slide.is('[style]')) {
            slide.attr('style', 'background-image: url(' + img + ')');
        }        
    }

    // Properties slider
    if ($('.rslides').length) {

        var i = 1;
        var count = $('.rslides li').length - 1;

        // Load first, second and last images initially        
        lazyLoading($('.rslides'), 0);
        lazyLoading($('.rslides'), 1);
        lazyLoading($('.rslides'), count);

        var slides = $('.rslides').responsiveSlides({
            auto: false,
            pager: true,
            nav: true,
            speed: 500,
            maxwidth: 1024,
            namespace: 'centered-btns',
            before: function () {
                setTimeout(function () {
                    lazyLoading($('.rslides'), i);
                }, 100);   
            }
        });

        $('img', slides).mousedown(function () {
            return false;
        });

        // Previous
        $('.prev').on('click', function () {
            i = (i > 1 ? i - 1 : count - 1);
        });

        // Next
        $('.next').on('click', function () {
            i = (i < count - 1 ? i + 1 : 1);
        });

        // Pager
        $('.centered-btns_tabs li a').on('click', function () {
            i = parseFloat($(this).html() - 1);
            // Load image either side of selection
            lazyLoading($('.rslides'), i - 1);
            if (i + 1 < count) lazyLoading($('.rslides'), i + 1);
            setTimeout(function () {
                i--;
            }, 300);
        });
    }

    // Featured banner
    if ($('.rslides-featured').length) {

        var slidesFeatured = $('.rslides-featured').responsiveSlides({
            auto: true,
            pager: true,
            nav: false,
            speed: $('.image-slider').data('speed'),
            timeout: $('.image-slider').data('timeout'),
            namespace: 'centered-btns',
        }).closest('div');

        $('.featured-image', slidesFeatured).mousedown(function () {
            return false;
        });
    }

    $('.iconDropDown').click(function () {

        if ($(this).parent('li').hasClass("open2")) {
            $(this).parent('li').removeClass('open2');
            $(this).removeClass('fa-chevron-up');
            $(this).addClass('fa-chevron-down');

        } else {
            $(this).parent('li').addClass('open2');


            $(this).removeClass('fa-chevron-down');
            $(this).addClass('fa-chevron-up');
        }
    });


    /* **************** *
    * Auto Submit Form  *
    * ***************** */

    $('.categories').on('click', 'input', function () {
        $(this).closest('form').submit();
    });

    /* ************************* *
    * Select 2 Distict and Area  *
    * ************************** */

    $("#EspcDistrictArea, #EspcDistrict").select2({
        containerCssClass: "dr"
    });

    $("#AreaSearch").click(function () {
        AreaSeach();

    });

    $("#DistrictSearch").click(function () {
        DistrictSearch();
    });

    $("#LocationSearch").click(function () {
        LocationSearch();

    });

    if ($("#AreaSearch").is(":checked")) {
        AreaSeach();
    }
    else if ($("#DistrictSearch").is(":checked")) {
        DistrictSearch();
    }
    else {
        LocationSearch();
    }

    function AreaSeach() {
        $('.draw-search-btn,.orform').hide();
        $('.geo-box-row').hide();
        $('.district-dropdown-row').hide();

        $('.area-dropdown-row').show();
    }

    function DistrictSearch() {
        $('.draw-search-btn,.orform').hide();
        $('.geo-box-row').hide();
        $('.area-dropdown-row').hide();

        $('.district-dropdown-row').show();
    }

    function LocationSearch() {
        $('.area-dropdown-row').hide();
        $('.district-dropdown-row').hide();

        $('.draw-search-btn,.orform').show();
        $('.geo-box-row').show();
    }
    
    $('#KeywordSearch').change(function () {
        if ($(this).is(':checked')) {
            $('#Location').attr('placeholder', $(this).data('keywordsearchhelp'));
        } else {
            $('#Location').attr('placeholder', $(this).data('locationsearchhelp'));
        }
    });

    /* ********************************** *
    * Lazy Load images on result listings *
    * *********************************** */
    $('.lazy').Lazy();
    
});
